import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { CopyToClipboard } from '@openx/components-core/lib/CopyToClipboard/CopyToClipboard.tsx';
import { HighlightedPhrase } from '@openx/components-core/lib/HighlightedPhrase/HighlightedPhrase.tsx';
import { Link } from '@openx/components-core/lib/Link/Link.tsx';
import { useTranslation } from 'react-i18next';

type NameCellProps = {
  id?: string | null;
  name?: string;
  pathTo?: string;
  subRowLabel: string;
  searchPhrase?: string;
};

export const NameCell = ({ id = '', name = '', pathTo, subRowLabel, searchPhrase }: NameCellProps) => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        ':hover': {
          '.on-hover-visible': {
            visibility: 'visible',
          },
        },
        alignItems: 'center',
        display: 'flex',
        paddingBottom: 0,
        paddingTop: 0,
        paddingRight: 4,
      }}
    >
      <Box>
        {pathTo && (
          <Link data-test="row-title" to={pathTo} state={{ navigateFromDealInsights: true }}>
            <HighlightedPhrase searchPhrase={searchPhrase}>{name}</HighlightedPhrase>
          </Link>
        )}
        {!pathTo && <HighlightedPhrase searchPhrase={searchPhrase}>{name}</HighlightedPhrase>}

        <Box sx={{ alignItems: 'center', display: 'flex', marginTop: 0.2 }} data-test="row-subtitle">
          <Typography
            variant="body2"
            color="textSecondary"
            sx={{
              display: 'inline',
            }}
          >
            <HighlightedPhrase searchPhrase={searchPhrase}>{subRowLabel}</HighlightedPhrase>
          </Typography>

          <Typography
            variant="body2Bold"
            sx={{
              marginLeft: 1,
            }}
          >
            <HighlightedPhrase searchPhrase={searchPhrase}>{String(id)}</HighlightedPhrase>
            {!!id && (
              <Box
                component="span"
                sx={{ display: 'inline', marginLeft: 0.5, visibility: 'hidden' }}
                className="on-hover-visible"
              >
                <CopyToClipboard tooltipText={t('Copy External Deal ID to clipboard')} text={id} />
              </Box>
            )}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};
